import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import _ from 'lodash';

import { toast } from 'react-toastify';

import 'react-loading-skeleton/dist/skeleton.css'

import { sendCreateMarketplaceRequest } from "../../../helpers/api-requests/marketplaces";
import { sendListEmailsRequest } from "../../../helpers/api-requests/emails";

import {Alert} from "react-daisyui";
import { MultiSelect } from "react-multi-select-component";

export default function CreateMarketplace() {
    const [formData, setFormData] = useState({});
    const [selectedEmails, setSelectedEmails] = useState([]);

    const [errors, setErrors] = useState('');
    const [emails, setEmails] = useState([]);

    const navigate = useNavigate();

    const tryCreate = async (event) => {
        const response = await sendCreateMarketplaceRequest({ ...formData, emails: selectedEmails.map(email => email.value) },() => {

        },() => {

        });

        if(response.status === 200) {
            if(response.message) {
                setErrors('');

                toast.success(response.message, {
                    hideProgressBar: true,
                });

                navigate("/marketplaces", {
                    replace: true,
                });
            } else {
                setErrors({...response});
            }
        } else {
            setErrors({...response});
        }
    };

    useEffect(() => {
        const fetchEmails = async () => {
            const response = await sendListEmailsRequest();

            setEmails(response.data.data);
        };

        fetchEmails();
    }, []);

    const handleFormDataChange = (wireKey, value) => {
        let newFormData = {...formData};

        _.set(newFormData, wireKey, value);

        setFormData(newFormData);
    }

    return (
        <>
            <div className="main-section-content">
                <div className="main-section-title-wrapper">
                    <h1>Stwórz link</h1>

                    <button className="button-primary" onClick={tryCreate}>
                        <div className="button-content">
                            <span>Zapisz</span>
                        </div>
                    </button>
                </div>

                <div className="columns-container">
                    <div className="left-column">
                        <div className="form">
                            <div className="form-card">
                                <div className="form-left-column">
                                    <div className="input">
                                        <label className="label" htmlFor="url">Link</label>
                                        <div className="input-wrapper">
                                            <input type="text" id="url" className="input-field  rounded-l rounded-r" placeholder="Podaj link" onChange={({target: {value}}) => handleFormDataChange('url', value)} />
                                        </div>
                                        { errors.errors?.url && <Alert className={'text-sm py-2 px-4 mt-2 rounded-lg'} status={'error'}>{ errors.errors.url[0] }</Alert> }
                                    </div>
                                    <div className="input">
                                        <label className="label" htmlFor="description">Opis</label>
                                        <div className="input-wrapper">
                                            <textarea id="description" className="input-field  rounded-l rounded-r" placeholder="Podaj opis" onChange={({target: {value}}) => handleFormDataChange('description', value)} />
                                        </div>
                                        { errors.errors?.description && <Alert className={'text-sm py-2 px-4 mt-2 rounded-lg'} status={'error'}>{ errors.errors.description[0] }</Alert> }
                                    </div>
                                    <div className="input">
                                        <label className="label" htmlFor="description">Opis</label>
                                        <div className="input-wrapper">
                                            {emails.length > 0 ? (
                                                <MultiSelect
                                                    options={emails.map(email => ({ label: email.email, value: email.id }))}
                                                    value={selectedEmails}
                                                    onChange={setSelectedEmails}
                                                    labelledBy="Select emails"
                                                />
                                            ) : (
                                                <p>Loading emails...</p>
                                            )}
                                        </div>
                                        { errors.errors?.description && <Alert className={'text-sm py-2 px-4 mt-2 rounded-lg'} status={'error'}>{ errors.errors.description[0] }</Alert> }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}